import { render, staticRenderFns } from "./SignInComponent.vue?vue&type=template&id=fffc4450&scoped=true&"
import script from "./SignInComponent.vue?vue&type=script&lang=ts&"
export * from "./SignInComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SignInComponent.vue?vue&type=style&index=0&id=fffc4450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffc4450",
  null
  
)

export default component.exports